package at.apa.statistictracker.data.model.statisticevent

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import kotlinx.serialization.modules.SerializersModule
import kotlin.js.JsExport

@Serializable
@JsExport
sealed class StatisticEvent {

    companion object {

        // according to https://github.com/Kotlin/kotlinx.serialization/blob/master/docs/polymorphism.md#sealed-classes
        // the polymorphic serialization of sub classes should work out of the box. However, without the below custom serializer,
        // the serialization fails. Therefore, all subclasses must be explicitly registered.
        private fun customSerializer() = Json {
            serializersModule = SerializersModule {
                polymorphic(
                    StatisticEvent::class,
                    MpsStatisticEvent::class,
                    MpsStatisticEvent.serializer()
                )
            }
            encodeDefaults = true // does serialize default values of properties
            explicitNulls = false // does not serialize null values
        }
    }

    // Support for copy in all sub classes.
    // A copy of an object may be needed if a created statistics event object must be modified on a different thread,
    // what is forbidden on native targets.
    abstract fun createCopy(): StatisticEvent

    fun serializeWithCustomSerializer() = customSerializer().encodeToJsonElement(serializer(), this)
}